/**
 * Сроки медленного режима — те же, что предлагает Discord. Одни на канал и
 * ветку: у ветки медленный режим свой, но выбирают его из того же списка.
 */
export const SLOWMODES: { seconds: number; label: string }[] = [
  { seconds: 0, label: "Выключен" },
  { seconds: 5, label: "5 секунд" },
  { seconds: 10, label: "10 секунд" },
  { seconds: 15, label: "15 секунд" },
  { seconds: 30, label: "30 секунд" },
  { seconds: 60, label: "1 минута" },
  { seconds: 120, label: "2 минуты" },
  { seconds: 300, label: "5 минут" },
  { seconds: 600, label: "10 минут" },
  { seconds: 900, label: "15 минут" },
  { seconds: 1800, label: "30 минут" },
  { seconds: 3600, label: "1 час" },
  { seconds: 7200, label: "2 часа" },
  { seconds: 21600, label: "6 часов" },
];
